import { render, staticRenderFns } from "./MultiPointMap.vue?vue&type=template&id=230dd15a&scoped=true&"
import script from "./MultiPointMap.vue?vue&type=script&lang=js&"
export * from "./MultiPointMap.vue?vue&type=script&lang=js&"
import style0 from "./MultiPointMap.vue?vue&type=style&index=0&id=230dd15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dd15a",
  null
  
)

export default component.exports